import { useContext, useEffect } from "react";
import { AppContext } from "../context";

export const useExtensions = (location: string) => {
  const {
    appState: {
      location: { prevLocation, currentLocation },
    },
    setAppState,
  } = useContext(AppContext);

  useEffect(() => {
    if (!prevLocation && !currentLocation) {
      setAppState((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          currentLocation: location,
        },
      }));
    } else if (location !== currentLocation) {
      setAppState((prev) => ({
        ...prev,
        location: {
          prevLocation: prev.location && prev.location.currentLocation,
          currentLocation: location,
        },
      }));
    }
  }, [location, prevLocation, currentLocation, setAppState]);

  return {
    prevLocation,
    currentLocation,
  };
};
